
import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Skeleton } from "@/components/ui/skeleton";
import { SubscriptionType } from "@/lib/supabase/types";
import { FormValues } from "./types";

interface SubscriptionSectionProps {
  form: UseFormReturn<FormValues>;
  userSubscriptions: SubscriptionType[];
  useGiftCard: boolean;
  isLoadingSubscriptions?: boolean;
}

export const SubscriptionSection: React.FC<SubscriptionSectionProps> = ({ 
  form,
  userSubscriptions, 
  useGiftCard,
  isLoadingSubscriptions = false
}) => {
  // Don't render anything if gift card is being used
  if (useGiftCard) {
    return null;
  }
  
  // Show loading state
  if (isLoadingSubscriptions) {
    return (
      <div className="space-y-2 py-2">
        <Skeleton className="h-4 w-[100px]" />
        <Skeleton className="h-10 w-full" />
      </div>
    );
  }
  
  // Don't render if no subscriptions available
  if (!userSubscriptions || userSubscriptions.length === 0) {
    return null;
  }
  
  console.log("Rendering subscription section with subscriptions:", userSubscriptions);
  
  return (
    <div className="space-y-4 bg-white p-4 rounded-lg border border-border">
      <h3 className="text-md font-medium">Use Subscription</h3>
      
      <FormField
        control={form.control}
        name="useSubscription"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Select subscription</FormLabel>
            <Select 
              onValueChange={field.onChange} 
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select a subscription" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="pay_individually">Pay individually</SelectItem>
                {userSubscriptions.map(sub => (
                  <SelectItem key={sub.id} value={sub.id}>
                    Subscription - {sub.remainingClasses} classes remaining
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
